'use strict';

angular.module('mean.projects').factory('Lots', ['$filter', 'Lot',
  function($filter, Lot) {
    var lots = [];
    var project = null;

    //constructor
    function Lots(project) {
        this.project = project;
        var self = this;

        if(!self.lots) self.lots = [];
        _.each(project.lots, function(lot) {
            self.lots.push(new Lot(lot));
        });
        //this.lots = lots;
    }

    //public prototypes
    Lots.prototype.addLot = function(lot) {
        lots.push(new Lot(lot));
    };

    Lots.prototype.removeLot = function(lot) {
        console.log('removeLot');
    };
    


    // Lot.number = angular.copy(number);

    // Lot.build = function(data) {
    //     console.log('figure this one out');
    // }

    return Lots;
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/projects/public/services/lots.js